module.exports = __webpack_public_path__ + "media/assets/images/landings/contact_center/32x32_outline_hexagon-b3a103f1772d891a2fe608e177de0128.svg";